import React, { useEffect, useRef, useState } from "react";
import {
  createChart,
  AreaSeries,
  createTextWatermark,
} from "lightweight-charts";
import btcIco from "../../images/btcIco.png";

const LiveBTCChart = () => {
  const chartContainerRef = useRef(null);
  const [price, setPrice] = useState(null);
  const [high24h, setHigh24h] = useState(null);
  const [low24h, setLow24h] = useState(null);

  useEffect(() => {
    const chart = createChart(chartContainerRef.current, {
      layout: {
        textColor: "black",
        background: { type: "solid", color: "white" },
      },
      // watermark: {
      //   color: "rgba(171, 71, 188, 0.3)",
      //   visible: true,
      //   text: "BTC/USDT Live",
      //   fontSize: 42,
      //   horzAlign: "center",
      //   vertAlign: "center",
      // },
      width: chartContainerRef.current.clientWidth,
      height: 500,
      timeScale: {
        timeVisible: true,
        secondsVisible: true,
      },
    });

    const areaSeries = chart.addSeries(AreaSeries, {
      topColor: "#2962FF",
      bottomColor: "rgba(41, 98, 255, 0.28)",
      lineColor: "#2962FF",
      lineWidth: 2,
    });

    chart.timeScale().fitContent();

    // ✅ Step 1: Load historical data
    fetch(
      "https://api.binance.com/api/v3/klines?symbol=BTCUSDT&interval=1m&limit=200"
    )
      .then((res) => res.json())
      .then((data) => {
        const formatted = data.map((d) => ({
          time: d[0] / 1000, // open time in seconds
          value: parseFloat(d[4]), // closing price
        }));
        areaSeries.setData(formatted); // show chart immediately
      });

    // ✅ Step 2: Live WebSocket for trades
    const wsTrades = new WebSocket(
      "wss://stream.binance.com:9443/ws/btcusdt@trade"
    );
    wsTrades.onmessage = (event) => {
      const trade = JSON.parse(event.data);
      const lastPrice = parseFloat(trade.p);
      const time = Math.floor(trade.T / 1000);

      setPrice(lastPrice);
      areaSeries.update({ time, value: lastPrice });
    };

    // ✅ Step 3: WebSocket for 24h stats
    const wsStats = new WebSocket(
      "wss://stream.binance.com:9443/ws/btcusdt@ticker"
    );
    wsStats.onmessage = (event) => {
      const stats = JSON.parse(event.data);
      setHigh24h(parseFloat(stats.h));
      setLow24h(parseFloat(stats.l));
    };

    const handleResize = () => {
      chart.applyOptions({ width: chartContainerRef.current.clientWidth });
    };
    window.addEventListener("resize", handleResize);

    return () => {
      wsTrades.close();
      wsStats.close();
      window.removeEventListener("resize", handleResize);
      chart.remove();
    };
  }, []);
  return (
    <div>
      <h2 className="homeHeading mb-2">
        Live BTC/USDT <span>Chart</span>
      </h2>
      <div style={{ marginBottom: "10px" }}>
        <div className="livePrice mb-3">
          <img src={btcIco} alt="" />
          {price ? `$ ${price.toLocaleString()}` : "Loading..."}
        </div>
        <div>
          <strong>24h High:</strong>{" "}
          {high24h ? `$${high24h.toLocaleString()}` : "Loading..."} <br />
        </div>
        <strong>24h Low:</strong>{" "}
        {low24h ? `$${low24h.toLocaleString()}` : "Loading..."}
      </div>
      <div ref={chartContainerRef} style={{ width: "100%", height: "500px" }} />
    </div>
  );
};

export default LiveBTCChart;
